import { useEffect, useState } from "react";
import { ballColorMap } from "../Utils/ColorMap";
import { wrapPieChartData, wrapPointData, wrapPyramidChartData } from "../Utils/PersonChartDataProcess";
import { getDecimalData } from "../Utils/utilFuncs";
import { BarChart } from "./Charts/BarChart";
import { BubbleChart } from "./Charts/BubbleChart"
import { IntegrateKZoneConfig, IntegrateKZoneConfig2, PitchPortionConfig, ZoneAreaBreakOutConfig } from "./Charts/configs/person_configs"
import { PieChart } from "./Charts/PieChart";

export const displayBallPortion = (data, colormap=false) => {
  data = data.filter((e) => (!isNaN(e.usage)))
  return data.map((e) => {
    return (
      <tr key={`portion_${e.tag}`}>
        <div className="portion_color_tag" style={{'background': colormap? colormap[e.tag]:ballColorMap[e.tag]}} />
        <td className="txt_left">{e.tag}</td>
        <td className="txt_right">{parseInt(e.usage)}%</td>
      </tr>
    )
  }).slice(0, 5)
}

export const calculateUsagePortion = (data) => {
  let usage_arr = []
  let bt_count = {}
  let total_count = 0
  for (let tag in data) {
    total_count += data[tag].length
    bt_count[tag] = data[tag].length
  }
  for (let tag in bt_count) {
    usage_arr.push({tag, usage: getDecimalData(bt_count[tag]*100, total_count, 0)})
  }

  return usage_arr
}

export const BallCountFrame = ({title, data, selected, timeAfter}) => {
  // console.log(data)
  const [pointData, setPointData] = useState(data.zone)
  const [usageData, setUsageData] = useState(data.usage)
  useEffect(() => {
    if (data.zone === undefined || selected === undefined) return
    // console.log(pointData, usageData, timeAfter)
    let newPointData = {}
    let timeCmp = timeAfter || new Date('2021-1-1')
    for (const t in data.zone) {
      if (selected.includes(t)) {
        newPointData[t] = data.zone[t].filter((e) => (e.time >= timeCmp))
      }
    }
    let newUsageData = calculateUsagePortion(newPointData)
    // console.log(newPointData, newUsageData)
    setPointData(newPointData)
    setUsageData(newUsageData)
  }, [selected, timeAfter])
  return (
    <div className="integrate_ball_block">
      <div className="integrate_ball_block_top">{title}</div>
      <div className="integrate_ball_content">
        <div className="integrate_ball_block_zone">
          <BubbleChart config={IntegrateKZoneConfig} className='integrate_chart_kzone' data={wrapPointData(pointData, 0.5)} />
        </div>
        <div className="integrate_ball_portion">
          <div className="integrate_ball_pie_chart">
            <PieChart data={wrapPieChartData(usageData, ballColorMap)} config={PitchPortionConfig} />
          </div>
          <div className="integrate_info">
            <table class="no_border">
              {displayBallPortion(usageData)}
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export const IntegrateKZoneFrame = ({title, data}) => {
  return (
    <div className="strike_ball_block">
      <div className="strike_ball_block_top">{title}</div>
      <BubbleChart data={{datasets:[]}} config={IntegrateKZoneConfig2} />
    </div>
  )
}

export const ZoneAreaBreakdownFrame = ({data}) => {
  const getPercentage = (data, tag) => {
    return parseInt(getDecimalData(data.portion.output[tag].total*100, data.portion.total, 0)) + '%'
  }
  const color1 = ["rgb(186, 112, 182)", "rgb(235, 139, 117)", "rgb(255, 231, 23)", "rgb(164, 164, 164)"]
  const color2 = ["rgba(186, 112, 182, 0.5)", "rgba(235, 139, 117, 0.5)", "rgba(255, 231, 23, 0.1)", "rgba(164, 164, 164, 0.5)"]
  return (
    <div className="zab-body">
      <div className="zab-portion">
        <div className="zab-title">
          <div className="zab-tag za-heart">Heart</div>
          <div className="zab-tag za-shadow">Shadow</div>
          <div className="zab-tag za-chase">Chase</div>
          <div className="zab-tag za-waste">Waste</div>
        </div>
        <div className="zab-portion-data">
          <div className="zab-data za-heart">{getPercentage(data, 'heart')}</div>
          <div className="zab-data za-shadow">{getPercentage(data, 'shadow')}</div>
          <div className="zab-data za-chase">{getPercentage(data, 'chase')}</div>
          <div className="zab-data za-waste">{getPercentage(data, 'waste')}</div>
        </div>
      </div>
      <div className="zab-swing-portion">
        <BarChart data={wrapPyramidChartData(['heart','shadow','chase','waste'], "Swing", "Take", data.bardata.swing, data.bardata.take, color1, color2)} config={ZoneAreaBreakOutConfig} />
      </div>
    </div>
  )
}